/**
 * Beta focus rollout: hide deprioritized recovery surfaces (Mobility, Bike Fit).
 * ESM for Vite/browser. Jest/Node uses betaFocusMode.cjs — keep in sync.
 */

const DEPRIORITIZED_RECOVERY_SCREENS = Object.freeze(['Mobility', 'BikeFit']);

/**
 * @param {{ env?: Record<string, string | undefined> }} [opts]
 */
export function isBetaFocusMode(opts = {}) {
  const env = opts.env ?? (typeof process !== 'undefined' ? process.env : {});
  if (env.BETA_FOCUS_MODE === '1') return true;
  if (env.EXPO_PUBLIC_BETA_FOCUS_MODE === '1') return true;
  return false;
}

/**
 * @param {ReadonlyArray<{ screen: string }>} links
 * @param {{ env?: Record<string, string | undefined> }} [opts]
 */
export function filterDeprioritizedRecoveryLinks(links, opts = {}) {
  if (!isBetaFocusMode(opts)) return links;
  return links.filter((item) => !DEPRIORITIZED_RECOVERY_SCREENS.includes(item.screen));
}
